import skladStore from "../../../../Stores/SkladStore";
import {Button} from "semantic-ui-react";
import React from "react";
import {observer} from "mobx-react-lite";

function UpdateButton() {
    return <Button basic
                   as={'a'}
                   primary compact
                   loading={skladStore.dataUpdateIsRunning}
                   disabled={skladStore.dataUpdateIsRunning}
                   onClick={() => skladStore.updateUserData()}
    >Обновить данные</Button>
}

export default observer(UpdateButton);